<template>
  <div class="mt-4 md:mt-5">
    <div class="charter-destination__summary">
      <h1 class="font-secondary">
        {{ destination.title }}
      </h1>
      <h3
        v-if="destination.subtitle"
        class="font-fancy"
      >
        {{ destination.subtitle }}
      </h3>
    </div>
    <div class="flex flex-wrap -mx-4 mb-6 md:mb-5">
      <div
        class="lg:w-6/12 px-4"
        :class="{ 'lg:w-12/12': !livingAreas?.list }"
      >
        <div
          v-if="content.preamble"
          class="h5 font-bold"
        >
          {{ content.preamble.trim() }}
        </div>
        <div
          class="mt-4 mb-6"
          v-html="content.text"
        />
      </div>
      <div
        v-if="livingAreas?.list"
        class="lg:w-6/12 px-4 relative"
      >
        <div class="post-it box-shadow w-full lg:max-w-[400px] rounded-[1.25rem]">
          <div class="flex flex-col m-3 md:m-4">
            <div class="flex flex-row w-full title-row">
              <div
                class="h3 font-bold title m-0"
                data-i18n="charterDestinationPostitTitle"
              >
                {{ $t('charterDestinationPostitTitle') }}
              </div>
              <fa
                class="icon"
                icon="sun-bright"
                width="32"
                height="32"
              />
            </div>
            <div
              v-for="(area, index) in livingAreas.list"
              :key="index"
              class="flex flex-row pt-4"
            >
              <div class="flex flex-row">
                <div class="items-center">
                  <span class="font-bold">
                    {{ area.name }}
                  </span>
                  <span class="ml-2">
                    {{ area.description }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Swiper
      class="full-width h-[350px]"
      :autoplay="{ delay: 10000 }"
      loop
      constant-display-navigation
      arrows-type="special"
      pagination
      dots-type="none"
      loading-skeleton-aspect="true"
      loading-skeleton-height="350px"
      prevent-swiper-update
      only-render-visible-slides
      arrows-size="xl"
    >
      <ResponsiveImage
        v-for="(img, index) in content.images"
        :key="index"
        class="size-full"
        :image="img.image_cloudinary"
        :alt="img.image_cloudinary"
        :lazy="false"
      />
    </Swiper>
  </div>
</template>

<script>
export default defineNuxtComponent({
  props: {
    content: {
      type: Object,
      default: () => ({}),
    },

    destination: {
      type: Object,
      default: () => ({}),
    },

    livingAreas: {
      type: Object,
      default: () => ({}),
    },
  },

  data () {
    return {
      zoom: 3,
      marker: null,
    }
  },

  computed: {
    images () {
      return this.content.images?.slice(0, 3) || []
    },

    gmapUrl () {
      return this.content?.gmapUrl
    },

    mapPreview () {
      return this.gmapUrl || (this.content?.latitude && this.content?.longitude)
    },
  },

  created () {
    this.setupMapPreview()
  },

  methods: {
    setupMapPreview () {
      const [lng, lat] = [this.content?.latitude || 0, this.content?.longitude || 0]
      const zoom = (this.content?.map_zoom_level || 10) - 1

      this.zoom = zoom
      this.marker = [lng, lat]
    },
  },
})
</script>

<style lang="scss" scoped>
:deep(.swiper-carousel-arrow-next) {
  right: -24px !important;
}

:deep(.swiper-carousel-arrow-prev) {
  left: -24px !important;
}
:deep(.swiper-carousel-arrow) {
  background: theme('colors.white') !important;
}
.post-it {
  height: fit-content;
  background-color: theme('colors.deep-turquoise');
  overflow: hidden;
  position: relative;
  box-shadow: theme('boxShadow.lg');
  z-index: 10;

  @media (max-width: theme('screens.md')) {
    margin-bottom: 20px;
  }
  .title-row {
    justify-content: space-between;
    align-items: start;
    .svg-inline--fa {
      height: unset;
    }
  }
  .title {
    font-family: theme('fontFamily.secondary');
  }
}
</style>